/**
 * Component Gallery page initialization
 *
 * Sets up interactive examples for the component gallery.
 */

// Import web components to register them
import './web-components';
import { showToast } from './web-components';

export function initGallery(): void {
  setupButtonEventDemo();
  setupToggleEventDemo();
  setupToastDemo();
}

function setupButtonEventDemo(): void {
  const btn = document.getElementById('eventDemoBtn');
  const output = document.getElementById('eventOutput');

  if (btn && output) {
    let clickCount = 0;
    btn.addEventListener('aw-click', () => {
      clickCount++;
      output.textContent = `Clicked ${clickCount} time${clickCount !== 1 ? 's' : ''}!`;
      output.classList.add('flash');
      setTimeout(() => output.classList.remove('flash'), 200);
    });
  }
}

function setupToggleEventDemo(): void {
  const toggle = document.getElementById('toggleDemoBtn');
  const output = document.getElementById('toggleEventOutput');

  if (toggle && output) {
    toggle.addEventListener('aw-change', (e: Event) => {
      const detail = (e as CustomEvent).detail;
      output.textContent = `${detail.checked ? 'ON' : 'OFF'} (name: ${detail.name})`;
      output.classList.add('flash');
      setTimeout(() => output.classList.remove('flash'), 200);
    });
  }
}

function setupToastDemo(): void {
  const successBtn = document.getElementById('toastSuccessBtn');
  const errorBtn = document.getElementById('toastErrorBtn');
  const warningBtn = document.getElementById('toastWarningBtn');
  const infoBtn = document.getElementById('toastInfoBtn');
  const undoBtn = document.getElementById('toastUndoBtn');
  const longBtn = document.getElementById('toastLongBtn');
  const persistBtn = document.getElementById('toastPersistBtn');

  successBtn?.addEventListener('aw-click', () => {
    showToast({ message: 'Settings saved!', type: 'success' });
  });

  errorBtn?.addEventListener('aw-click', () => {
    showToast({ message: 'Something went wrong', type: 'error' });
  });

  warningBtn?.addEventListener('aw-click', () => {
    showToast({ message: 'Check your input', type: 'warning' });
  });

  infoBtn?.addEventListener('aw-click', () => {
    showToast({ message: 'New update available', type: 'info' });
  });

  undoBtn?.addEventListener('aw-click', () => {
    showToast({
      message: 'Item deleted',
      type: 'info',
      undoCallback: () => {
        showToast({ message: 'Item restored', type: 'success' });
      },
    });
  });

  longBtn?.addEventListener('aw-click', () => {
    showToast({ message: 'This toast stays for 8 seconds', type: 'info', duration: 8000 });
  });

  persistBtn?.addEventListener('aw-click', () => {
    showToast({ message: 'Dismiss this manually', type: 'info', duration: 0 });
  });
}
